import { render } from "./EstoqueHeader.vue?vue&type=template&id=a11715f4&scoped=true"
import script from "./EstoqueHeader.vue?vue&type=script&lang=js"
export * from "./EstoqueHeader.vue?vue&type=script&lang=js"

import "./EstoqueHeader.vue?vue&type=style&index=0&id=a11715f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a11715f4"]])

export default __exports__